import { ListagemPadrao } from "../../padronizado/listagem-padrao";
import { CodigoSistemaInterface } from "../../../types/CodigoSistemaInterface";
import { verificaSeAtivoERetornaBadge } from "../../../utils/verificaSeAtivoERetornaBadge/verificaSeAtivoERetornaBadge";

export const CodigiodoSistema: React.FC = () => {
  // Definição das colunas da tabela
  const colunas: {
    titulo: string;
    campo: keyof CodigoSistemaInterface | ((item: CodigoSistemaInterface) => React.ReactNode);
    alinhamento?: 'start' | 'center' | 'end';
  }[] = [
    { titulo: "Tabela", campo: "tabela" },
    { titulo: "Descrição", campo: "descricao" },
    { 
      titulo: "Situação", 
      campo: (codigo) => verificaSeAtivoERetornaBadge(String(codigo.situacao)),
      alinhamento: "center" 
    },
  ];

  // Campos que serão utilizados na pesquisa
  const camposPesquisa: (keyof CodigoSistemaInterface)[] = [
    "tabela",
    "descricao"
  ];

  // Função para personalizar a mensagem de confirmação de exclusão
  const mensagemConfirmacaoExclusao = (codigo: CodigoSistemaInterface) => {
    return `Tem certeza que deseja excluir o código do sistema \n ${codigo.descricao}?`;
  };

  // Função para retornar o parâmetro de exclusão
  const getParametroExclusao = (codigo: CodigoSistemaInterface) => {
    return codigo.tabela;
  };

  return (
    <ListagemPadrao<CodigoSistemaInterface>
      titulo="Códigos do Sistema"
      endpoint="/codigosistema"
      colunas={colunas}
      campoId="tabela"
      rotaBase="/cadastro/codigodosistema"
      camposPesquisa={camposPesquisa}
      usaPaginacaoServidor={false}
      mensagemConfirmacaoExclusao={mensagemConfirmacaoExclusao}
      parametroExclusao={getParametroExclusao}
    />
  );
}; 